import {messages} from '../components/common/Translations';
import {plainJSTranslator} from "../common/PlainJSTranslator";

export function validateMaxLength({values, fields, length, errors}) {
    fields.forEach(fieldName => {
        if(!values[fieldName]) {
            return;
        }

        if(values[fieldName].length > length) {
            errors[fieldName] =  plainJSTranslator.formatMessage(messages.validationErrorLengthToLong, {length})
        }
    });

    return errors;
}


// WEBPACK FOOTER //
// ./web/src/common/validationUtils.js